import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Table, Container, Row, Col, Form } from 'react-bootstrap';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';

import Loginheader from '../Loginheader';
import Menu from '../Menu';
import * as Common from '../Common';
import Dialog from '../Dialog';


function Master_User_List() {
    const navigate = useNavigate();
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [scrMode, setScrMode] = useState("Q");  // "Q A E "

    const [userData, setUserData] = useState([]);
    const [showAddEditForm, setAddEditFormShow] = useState(false);
    const [showAddNewBtn, setShowAddNewBtn] = useState(true);

    const [umSrNo, setUmSrNo] = useState(0);
    const [umUserName, setUmUserName] = useState("");
    const [umId, setUmId] = useState("");
    const [umMob, setUmMob] = useState("");
    const [umEml, setUmEml] = useState("");
    const [umEnable, setUmEnable] = useState(0);
    const [ddEnableOptions, setDdEnableOptions] = useState([]);
    const [umEntityCode, setUmEntityCode] = useState(false);
    const [umEntityType, setUmEntityType] = useState("0");
    const [ddEntityTypeOptions, setDdEntityTypeOptions] = useState([]);
    const [umActive, setUmActive] = useState(0);
    const [branchData, setBranchData] = useState([]);

    const [ddActiveOptions, setDdActiveOptions] = useState([]);
    const [ddEntityCodeOptions, setDdEntityCodeOptions] = useState([]);

    const [umRightBranch, setUmRightBranch] = useState(0);
    const [ddUmRightBranchOptions, setDdUmRightBranchOptions] = useState([]);
    const [umRightBranchAllow, setUmRightBranchAllow] = useState(0);

    const [umRightGroup, setUmRightGroup] = useState(0);
    const [ddRightGroupOptions, setDdRightGroupOptions] = useState([]);

    const [userRight, setUserRight] = useState([]);
    //jitendra
    const [loactionList, setLocationList] = useState([])
    const [selectedLocation, setSelectedLocation] = useState();
    const [selectedLocationStatus, setSelectedLocationStatus] = useState(1);
    const [locationAllow, setLocationAllow] = useState();
    const [selectedLocationList, setSelectedLocationList] = useState([])


    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            setDdActiveOptions([{ name: 'Active', value: "1" }, { name: 'Inactive', value: "0" }]);
            setDdEnableOptions([{ name: 'Active', value: "1" }, { name: 'Inactive', value: "0" }]);
            setDdEntityTypeOptions([{ name: 'Select', value: "0" }, { name: 'Agent', value: "A" }, { name: 'Branch', value: "B" }]);
            setDdEntityCodeOptions([{ name: 'Select', value: "0" }]);
            Common.callApi(Common.apiRight, [sid, 'all', 'USER'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/'); // no query right
                }
            });
            Common.callApi(Common.apiUser, [sid, 'listjson'], function (result) {
                setUserData(JSON.parse(result));
            });
            Common.callApi(Common.apiEntity, [sid, 'ddlistjson', 'B'], function (result) {
                setDdUmRightBranchOptions(JSON.parse(result));
            });
            Common.callApi(Common.apiRightGroup, [sid, 'ddlistjson'], function (result) {
                setDdRightGroupOptions(JSON.parse(result));
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    function agentAvailableList(agentId) {
        Common.callApi(Common.apiEntityLocation, [sid, 'allagentavailablelocation', JSON.stringify(agentId)], function (result) {
            setLocationList(JSON.parse(result));
            console.log("LIST", JSON.parse(result))
        });
    }


    function getList() {
        Common.callApi(Common.apiUser, [sid, 'listjson'], function (result) {
            setUserData(JSON.parse(result));
        });
    }

    function addNew() {
        setUmSrNo(0);
        setUmUserName("");
        setUmId("");
        setUmMob("");
        setUmEml("");
        setUmEnable(1);
        setUmEntityType("0");
        setUmEntityCode(0);
        setScrMode("A");
        setUmActive(1);
        setUmRightBranch(0);
        setUmRightGroup(0);
        setBranchData([]);
        setAddEditFormShow(true);
        setShowAddNewBtn(false);
    }

    function fillMasterHead(id) {
        setUmEntityType(id);
        Common.callApi(Common.apiEntity, [sid, 'ddlistjson', id], function (result) {
            setDdEntityCodeOptions(JSON.parse(result));
        });
    }

    function saveData() {
        if (umUserName === "") {
            setMsgText(Common.getMessage("MSG0006"));
            setMsgBox(true);
        } else {
            var object1 = {
                umSrNo: umSrNo,
                umUserName: umUserName,
                umId: umId,
                umMob: umMob,
                umEml: umEml,
                umEnable: umEnable,
                umEntityType: umEntityType,
                umEntityCode: umEntityCode,
                umActive: umActive,
                umRightGroup: umRightGroup
            };
            Common.callApi(Common.apiUser, [sid, 'save', umSrNo, JSON.stringify(object1)], function (result) {
                let resp = JSON.parse(result);
                if (resp.err === "") {
                    setScrMode("Q");
                    setAddEditFormShow(false);
                    setShowAddNewBtn(true);
                    getList();
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
            });
        }
    }

    function cancelData() {
        setAddEditFormShow(false);
        setShowAddNewBtn(true);
    }

    function fillEditForm(id) {
        Common.callApi(Common.apiUser, [sid, 'detail', id], function (result) {
            setScrMode("E");
            let resp = JSON.parse(result);
            setUmSrNo(resp.umSrNo);
            setUmUserName(resp.umUserName);
            setUmId(resp.umId);
            setUmMob(resp.umMob);
            setUmEml(resp.umEml);
            setUmEnable(resp.umEnable);
            setUmEntityType(resp.umEntityType);
            setUmActive(resp.umActive);
            setBranchData(resp.umDetail);
            getAgentList(resp.umSrNo, resp.umEntityCode);
            setUmEntityCode(resp.umEntityCode);
            Common.callApi(Common.apiEntity, [sid, 'ddlistjson', resp.umEntityType], function (result) {
                setDdEntityCodeOptions(JSON.parse(result));
            });
            if (resp.umEntityType === "B") {
                setUmRightBranch(0);
            }
            setUmRightGroup(resp.umRightGroup);
            setAddEditFormShow(true);
            setShowAddNewBtn(false);
            agentAvailableList(resp.umEntityCode);
        });
    }

    function saveRight() {
        if (umRightBranch === 0) {
            setMsgText(Common.getMessage("MSG0006"));
            setMsgBox(true);
        } else {
            var object1 = {
                umSrNo: umSrNo,
                umRightBranch: umRightBranch,
                locationAllow: locationAllow,
                umRightBranchAllow: umRightBranchAllow
            };
            Common.callApi(Common.apiUser, [sid, 'saveright', JSON.stringify(object1)], function (result) {
                if (result === "") {
                    fillEditForm(umSrNo);
                } else {
                    setMsgText(result);
                    setMsgBox(true);
                }
            });
        }
    }
    //jitendra
    function saveLocationRight() {
        // console.log(selectedLocation);
        if (!selectedLocation) {
            setMsgText(Common.getMessage("MSG0006"));
            setMsgBox(true);
        } else {
            var object = {
                umSrNo: umSrNo,
                selectedLocation: selectedLocation,
                selectedLocationStatus: selectedLocationStatus
            };
            Common.callApi(Common.apiEntityLocation, [sid, 'savelocationright', JSON.stringify(object)], function (result) {
                const resp = JSON.parse(result)
                if (resp.status) {
                    getAgentList()
                    setMsgText(resp.msg);
                    setMsgBox(true);
                    setSelectedLocation();
                    setSelectedLocationStatus(1);
                } else {
                    setMsgText(result);
                    setMsgBox(true);
                }
            });
        }
    }
    function getAgentList(agentSrno, entityCode) {
        let obj = {
            srNo: umSrNo === 0 ? agentSrno : umSrNo,
            entityCode: umEntityCode ? umEntityCode : entityCode
        }
        Common.callApi(Common.apiEntityLocation, [sid, 'getagentlist', JSON.stringify(obj)], function (result) {
            const resp = JSON.parse(result)
            if (resp.status) {
                setSelectedLocationList(resp.list);
            }
        });

    }

    function canEdit() {
        if (userRight.edit === "1" || userRight.add === "1") {
            return true;
        } else {
            return false;
        }
    }

    return (
        <>
            <Loginheader></Loginheader>
            <Menu></Menu>
            <Container fluid >
                <Row>
                    <Col>
                        <h1>User Master</h1>
                    </Col>
                </Row>
                {showAddNewBtn ?
                    <Row>
                        <Col>
                            {userRight.add === "1" ?
                                <Button variant="outline-primary" size="sm" onClick={addNew}>Add New</Button>
                                : null}
                        </Col>
                    </Row>
                    : null
                }

                <Row><Col>&nbsp;</Col></Row>
                {showAddEditForm ?
                    <>
                        <Row>
                            <Col>
                                <Form>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Serial Number</Form.Label>
                                                <Form.Control type="text" placeholder="Serial Number" value={umSrNo} disabled />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>User Name<span className="mandatory">*</span></Form.Label>
                                                <Form.Control type="text" placeholder="User" maxLength={50}
                                                    value={umUserName} onChange={(e) => setUmUserName(e.target.value)} autoComplete="off"
                                                    disabled={!canEdit()} />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>User ID<span className="mandatory">*</span></Form.Label>
                                                <Form.Control type="text" placeholder="User ID" maxLength={50} disabled={scrMode !== "A"}
                                                    value={umId} onChange={(e) => setUmId(e.target.value)} autoComplete="off" />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Mobile<span className="mandatory">*</span></Form.Label>
                                                <Form.Control type="text" placeholder="Mobile" maxLength={50}
                                                    value={umMob} onChange={(e) => setUmMob(e.target.value)} autoComplete="off"
                                                    disabled={!canEdit()} />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Email<span className="mandatory">*</span></Form.Label>
                                                <Form.Control type="email" placeholder="Email" maxLength={50} autoComplete="off"

                                                    value={umEml} onChange={(e) => setUmEml(e.target.value)}
                                                    onBlur={(e) => Common.validtateEmail(e.target.value, setUmEml)}
                                                    disabled={!canEdit()}

                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Enable</Form.Label>
                                                <Form.Select
                                                    value={umEnable}
                                                    onChange={(e) => setUmEnable(e.target.value)}
                                                    disabled={!canEdit()}
                                                >
                                                    {ddEnableOptions.map((res) =>
                                                        <option key={res.value} value={res.value}>{res.name}</option>
                                                    )}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Status</Form.Label>
                                                <Form.Select
                                                    value={umActive}
                                                    onChange={(e) => setUmActive(e.target.value)}
                                                    disabled={!canEdit()}
                                                >
                                                    {ddActiveOptions.map((res) =>
                                                        <option key={res.value} value={res.value}>{res.name}</option>
                                                    )}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Type</Form.Label>
                                                <Form.Select
                                                    disabled={scrMode === "E"}
                                                    value={umEntityType}
                                                    onChange={(e) => fillMasterHead(e.target.value)}
                                                >
                                                    {ddEntityTypeOptions.map((res) =>
                                                        <option key={res.value} value={res.value}>{res.name}</option>
                                                    )}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        {
                                            umEntityType === "A" ?
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Master Head<span className="mandatory">*</span></Form.Label>
                                                        <Form.Select
                                                            value={umEntityCode}
                                                            onChange={(e) => setUmEntityCode(e.target.value)}
                                                        >
                                                            {ddEntityCodeOptions.map((res) =>
                                                                <option key={res.value} value={res.value}>{res.name}</option>
                                                            )}
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                : <Col>&nbsp;</Col>
                                        }
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Group<span className="mandatory">*</span></Form.Label>
                                                <Form.Select
                                                    value={umRightGroup}
                                                    onChange={(e) => setUmRightGroup(e.target.value)}
                                                    disabled={!canEdit()}
                                                >
                                                    {ddRightGroupOptions.map((res) =>
                                                        <option key={res.value} value={res.value}>{res.name}</option>
                                                    )}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col>&nbsp;</Col>
                                        <Col>&nbsp;</Col>
                                    </Row>
                                    <Row>
                                        <Col>&nbsp;</Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            {
                                                canEdit() ? <>
                                                    <Button variant="outline-success" size="sm" onClick={() => saveData()}>Save</Button>&nbsp;
                                                </> : null
                                            }
                                            <Button variant="outline-danger" size="sm" onClick={() => cancelData()}>Cancel</Button>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>&nbsp;</Col>
                                    </Row>
                                </Form>
                            </Col>
                        </Row>
                        {
                            umEntityType === "B" ?
                                <>
                                    {
                                        canEdit() ? <>
                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Branch</Form.Label>
                                                        <Form.Select
                                                            value={umRightBranch}
                                                            onChange={(e) => setUmRightBranch(e.target.value)} >
                                                            {ddUmRightBranchOptions.map((res) =>
                                                                <option key={res.value} value={res.value}>{res.name}</option>
                                                            )}
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>
                                                            Allowed
                                                        </Form.Label>
                                                        <Form.Select
                                                            value={umRightBranchAllow}
                                                            onChange={(e) => setUmRightBranchAllow(e.target.value)} >
                                                            <option key="1" value="1" >YES</option>
                                                            <option key="0" value="0" >No</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>&nbsp;</Form.Label><br></br>
                                                        <Button variant="outline-success" size="sm"
                                                            onClick={() => saveRight()}>Change Right</Button>
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                        </> : null
                                    }

                                    <Row><Col>&nbsp;</Col></Row>
                                    <Row>
                                        <Col>
                                            <Table responsive striped bordered hover>
                                                <thead>
                                                    <tr>
                                                        <th>Sr No</th>
                                                        <th>Branch Name</th>
                                                        <th>Allowed</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {branchData.map((res) =>
                                                        <tr key={res.entity_id}>
                                                            <td className="textRight">{res.entity_id}</td>
                                                            <td>{res.entity_name}</td>
                                                            <td>{res.entity_right}</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>



                                    <Row><Col>&nbsp;</Col></Row>
                                </>
                                : null
                        }
                        {
                            umEntityType === "A" ?
                                <>

                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Location</Form.Label>
                                                <Form.Select
                                                    value={selectedLocation}
                                                    onChange={(e) => setSelectedLocation(e.target.value)} >
                                                    {loactionList.map((res) =>
                                                        <option key={res.value} value={res.value}>{res.name}</option>
                                                    )}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>
                                                    Allowed
                                                </Form.Label>
                                                <Form.Select
                                                    value={selectedLocationStatus}
                                                    onChange={(e) => setSelectedLocationStatus(e.target.value)} >
                                                    <option key="1" value="1" >YES</option>
                                                    <option key="0" value="0" >No</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>&nbsp;</Form.Label><br></br>
                                                <Button variant="outline-success" size="sm"
                                                    onClick={saveLocationRight}>Change Right</Button>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row><Col>&nbsp;</Col></Row>
                                    <Row>
                                        <Col>
                                            <Table responsive striped bordered hover>
                                                <thead>
                                                    <tr>
                                                        <th>Sr No</th>
                                                        <th>Location </th>
                                                        <th>Allowed</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {selectedLocationList.map((res, index) =>
                                                        <tr key={res.mel_srno}>
                                                            <td className="textRight">{index + 1}</td>
                                                            <td>{res.mel_location}</td>
                                                            <td>{res.all_status === "0" ? "Inactive" : "Active"}</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>



                                    <Row><Col>&nbsp;</Col></Row>
                                </>
                                : null
                        }

                    </>
                    : <>
                        <Row>
                            <Col >
                                <Table responsive striped bordered hover>
                                    <thead>
                                        <tr>
                                            {userRight.query === "1" ? <th></th> : null}
                                            <th className="textRight">Sr No</th>
                                            <th >User Name</th>
                                            <th>User ID</th>
                                            <th >Status</th>
                                        </tr>
                                    </thead>
                                    <tbody id="tblBody">
                                        {userData.map((res) =>
                                            <tr key={res.um_srno}>
                                                {userRight.query === "1" ?
                                                    <td className="textCenter" >
                                                        <span className="handCursor" onClick={() => fillEditForm(res.um_srno)} >
                                                            <div className="colorThemeBlue"><FontAwesomeIcon icon={faEdit} /></div>
                                                        </span>
                                                    </td>
                                                    : null
                                                }
                                                <td className="textRight">{res.um_srno}</td>
                                                <td>{res.um_username}</td>
                                                <td>{res.um_id}</td>
                                                <td>{res.um_active}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </>
                }


            </Container>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
        </>
    );
}
export default Master_User_List;